import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Badge, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import logoCentre from '../../assets/images/logoCentre.PNG';
import menuIcon from '../../assets/images/menu.png';
import closeIcon from '../../assets/images/fermer.png';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import LogoutIcon from '@mui/icons-material/Logout';
import { setUser } from '../../store/userSlice';
import CustomBackdrop from '../../components/backdrop';
import CustomDrawer from './drawer';

function ItemNavBar({
  item,
  isActive=false,
  menu=false,
  link
}) {
  if (menu) {
    return (
      <Link to={link}>
        <div
          className={`font-inter font-medium text-center text-white hover:bg-primary py-2 cursor-pointer text-lg w-full ${isActive && 'bg-primary'}`}
        >
          {item}
        </div>
      </Link>
    );
  } else {
    return (
      <Link
        to={link}
        className={`font-inter font-medium hover:text-primary cursor-pointer mx-5 text-xl ${isActive && 'text-primary'}`}
      >
        {item}
      </Link>
    );
  }
}


export default function Header({
  activeItem,
  reservations,
  messages,
  badgeNotification
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [badgeContent, setBadgeContent] = useState(0);

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  // const [reservations, setReservations] = useState([]);
  // const [messages, setMessages] = useState([]);

  const dispatch = useDispatch();

  const navBarItems = [
    {id: 1, item: 'Dashboard', link: '/dashboard'},
    {id: 2, item: 'Réservations', link: '/reservations'},
    {id: 3, item: 'Calendrier', link: '/calendrier'},
    {id: 4, item: 'Messages', link: '/messages'},
    {id: 4, item: 'Configurations', link: '/configurations'},
    {id: 5, item: 'Event', link: '/event'},
  ];

  // async function getNotificationData() {
  //   const url = `${getEnvironement().API_URL}/notificationData`;
  //   await axios.post(url)
  //     .then((res) => {
  //       console.log(res);
  //       setReservations(res.data.reservations);
  //       setMessages(res.data.messages);
  //     })
  //     .then(() => setBadgeContent(reservations.length + messages.length))
  //     .catch((err) => console.log(err));
  // }

  // const getNotificationData = useCallback(async () => {
  //   const url = `${getEnvironement().API_URL}/notificationData`;
  //   axios.post(url)
  //     .then((res) => {
  //       console.log(res);
  //       setReservations(res.data.reservations);
  //       setMessages(res.data.messages);
  //     })
  //     .then(() => setBadgeContent(reservations.length + messages.length))
  //     .catch((err) => console.log(err));
  // }, [reservations, messages]);

  // useEffect(() => {
  //   getNotificationData();
  // }, [openDrawer, allReservations]);

  // useEffect(() => {
  //   console.log(reservations);
  // }, [reservations]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <CustomDrawer
        open={openDrawer}
        handelClose={() => setOpenDrawer(false)}
        reservations={reservations}
        messages={messages}
      />
      <div className='flex justify-center w-full'>
        <div className='flex justify-between items-center ml-6 mr-10 w-full 3xl:w-[1200px]'>
          <Link to='/admin'>
            <img src={logoCentre} alt='logo center' className='w-[200px]'/>
          </Link>
          <div className='sm:flex flex-wrap justify-center hidden my-5'>
            {navBarItems.map((itemdata) => {
              return (
                <ItemNavBar
                  key={itemdata.id}
                  item={itemdata.item}
                  isActive={activeItem === itemdata.item}
                  link={itemdata.link}
                />
              )
            })}
          </div>
          <div className='hidden sm:flex items-center'>
            <IconButton onClick={() => setOpenDrawer(true)}>
              <Badge
                badgeContent={badgeNotification}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: '#A31732',
                    color: '#fff',
                  },
                }}
                showZero
              >
                {
                  badgeNotification === 0
                  ? (<NotificationsNoneIcon sx={{color: 'black', fontSize: '30px'}} />)
                  : (<NotificationsIcon sx={{color: 'black', fontSize: '30px'}} />)
                }
                
              </Badge>
            </IconButton>
            <span className='mx-2 text-black text-3xl relative bottom-1.5'>|</span>
            <IconButton
              onClick={() => {
                setOpenBackdrop(true);
                setTimeout(() => {
                  dispatch(setUser(null));
                  setOpenBackdrop(false);
                }, 1000)
              }}
            >
              <LogoutIcon sx={{color: 'black', fontSize: '30px'}} />
            </IconButton>
          </div>
          <div className='sm:hidden relative left-3'>
            <IconButton
              onClick={() => setIsMenuOpen((isMenuOpenPrevState) => !isMenuOpenPrevState)}
            >
              <div className='rounded-full bg-primary p-4'>
                <img src={menuIcon} alt='menu' className={`w-5 ${isMenuOpen && 'hidden'}`}/>
                <img src={closeIcon} alt='menu' className={`w-5 ${!isMenuOpen && 'hidden'}`}/>
              </div>
            </IconButton>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className='shadow w-full bg-secondary sm:hidden border-4 border-primary'>
          {navBarItems.map((itemdata) => {
            return (
              <ItemNavBar
                key={itemdata.id}
                item={itemdata.item}
                isActive={activeItem === itemdata.item}
                link={itemdata.link}
                menu
              />
            )
          })}
          <div onClick={() => {
            setIsMenuOpen(false);
            dispatch(setUser(null));
          }}>
            <ItemNavBar item='Se déconnecter' setOpenMenu={setIsMenuOpen} menu />
          </div>
        </div>
      )}
      <div className='flex justify-center w-full bg-primary'>
        <div className='w-full bg-primary flex justify-between items-center px-10 3xl:px-0 3xl:w-[1200px]'>
          <p className='text-white font-inter font-semiBold text-lg'>Portail de résérvation de salle</p>
          <p className='hidden sm:inline text-white font-inter font-semiBold text-lg text-end'>Room booking portal</p>
          <p className='sm:hidden text-white font-inter font-semiBold text-lg text-end'>M.T.C</p>
        </div>
      </div>
    </>
  );
}
